import {ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, ViewRef,Output, ViewChild,ElementRef} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {LoadingService} from "../../services/LoadingService";
import {FileUploader, FileUploaderOptions, FileUploadModule} from "ng2-file-upload";
import {Session} from "../../services/Session";
import FroalaEditor from 'froala-editor';
import {FroalaEditorModule} from "angular-froala-wysiwyg";
import {TOAST_TYPE} from "../../constants/Tpiq.constants";
import {ToastService} from "../../services/Toast.service";
import {SwitchBoard} from '../../services/SwitchBoard';
import {ManageTaxStrategiesServices} from "../../tpiq-services/manage-tax-strategies.service";
import {CollaborationService} from "../../services/Collaboration.service";
import {CacheService} from '../../services/cache.service';
import {PageTitleService} from '../../services/PageTitle';
import {DomSanitizer} from '@angular/platform-browser';
import {DateFormater} from '../../services/DateFormatter.service';
import { environment } from '../../../environments/environment';

declare const _: any;
declare const moment: any;

@Component({
  selector: 'app-new-post',
  standalone: true,
  imports: [CommonModule, FormsModule, FileUploadModule, FroalaEditorModule],
  templateUrl: './new-post.component.html',
  styleUrl: './new-post.component.scss'
})
export class NewPostComponent implements OnInit, OnDestroy {
  selectedCompanyId: string;
  internalMails: Array<any> = [];
  externalMails: Array<any> = [];
  externals: Array<any> = [];
  internals: Array<any> = [];
  teamUsersData: Array<any> = [];
  teamMails: Array<any> = [];
  dupInternalMails: Array<any> = [];
  dupExternalMails: Array<any> = [];
  dupTeamsMails: Array<any> = [];
  postEntityType = true;
  snapShots = ['default', 'mountain', 'super_square'];
  defaultSnapShots = ['default_2', 'default_3', 'default_4'];
  mailObj: any;
  uploader: FileUploader;
  generatedId: string;
  attachmentType: string;
  uploadingDocumentName: string;
  users: Array<any> = [];
  allUsers: Array<any> = [];
  showMentionDropdown = false;
  selectedLabelNames: Array<any> = [];
  selectedUrgentLabelNames: Array<any> = [];
  mentions: Array<any> = [];
  mentionIds: Array<any> = [];
  metaData: string;
  metaDataEdit: false;
  newPost: any = {message: '', html_message: ''};
  postUploadResp: Array<any> = [];
  isDisplayThanosAlert = false;
  user: any;
  selectedLabels = [];
  selectedUrgentLabels = [];
  urgencyPostLabels = [];
  orgName: string;
  isCustomer: boolean;
  metaDataCopy: string;
  uploadCount = 0;
  showDropdowns = true;
  uploadingDocumentNotes: string;
  mentionUsers: Array<any> = [];
  userId: string;
  toggledGiphy = false;
  isGify = false;
  gifyUrl: any;
  internalClearAll = false;
  externalClearAll = false;
  teamsClearAll = false;
  @Input() org: string;
  @Input() channelType;
  @Input() pageType;
  @Input() entityType;
  @Input() entityId;
  @Input() cachingPostType;
  @Input() posts;
  @Input() isPostFromMail;
  @Input() isUser;
  @Input() isTeam;
  @Input() isDocView;
  @Input() labelTypes;
  @Input() urgentLabelTypes;
  @Input() isOrg;
  @Input() isQountOrg;
  @Input() firms;
  @Input() taskPosts;
  @Input() postTemplates;
  @Input() isSecureUploadPost;
  @Input() integrationPost;
  @Input() set companyId(id) {
    this.selectedCompanyId = id;
    this.org = Session.getOrg();
    this.uploaderUpdate();
    this.buildItemForm();
  }

  @Output() onPostCreation: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('newPostEditor') private newPostEditor: ElementRef;
  destroy$: EventEmitter<void> = new EventEmitter<void>();
  editor: any;
  editorOptions = {
    heightMin: 150,
    heightMax: 200,
    autofocus: true,
    toolbarContainer: '.formatter-menu',
    listAdvancedTypes: false,
    linkAlwaysBlank: true,
    enter: FroalaEditor.ENTER_DIV,
    colorsText: ['#14B5F0', '#3574e3', '#DFCF6A', '#2D62BF', '#09A4DE', '#475E79', '#3474e3', '#102D79', '#434343'],
    key: environment.froalaKey,
    pasteDeniedAttrs: ['class', 'id', 'style'],
    imageUploadRemoteUrls: false,
    inlineMode: false,
    textarea: true,
    events: {
      initialized: (e) => {
        this.editor = e.getEditor();

        this.editor.events.on('drop', (dropEvent: any) => {
          dropEvent.preventDefault();
          return false;
        }, true);

        this.editor.events.on('image.beforePasteUpload', (img) => {
          const base = this;
          const base64 = img.getAttribute('src');
          const arr = base64.split(',');
          const mime = arr[0].match(/:(.*?);/)[1];
          const exactMime = mime.split('/')[1];
          const imageName = 'image_' + Math.floor((Math.random() * 100) + 1) + '.' + exactMime;
          this.urltoFile(base64, imageName, mime)
            .then((file: any) => {
              const files: any = [];
              files.push(file);
              base.uploader.addToQueue(files);
              base.startUpload(img, 'newPost');
            });
          this.editor.html.set(base.newPost.message);
          return false;
        }, true);
      },
    },
    toolbarButtons: ['bold', 'italic', 'underline', 'textColor', 'backgroundColor', 'formatOL', 'formatUL', 'quote', 'insertLink'],
    toolbarSticky: false,
    toolbarBottom: true,
    toolbarStickyOffset: 10,
    placeholderText: 'Enter Post Message ...',
    charCounterCount: false,
    quickInsertTags: [],
    linkList: [
      {
        text: 'Google',
        href: 'http://google.com',
        target: '_blank',
        rel: 'nofollow'
      }
    ],
    zIndex: 1,
    theme: 'royal'
  };
  selectedCompany: any = {};
  docTypeList = ['doc', 'pdf', 'docx', 'xls'];
  postTypes: Array<any> = [
    {key: 'internal', value: 'Internal'},
    {key: 'external', value: 'External'}
  ];
  orgTypes: Array<any> = [{orgId: 'all', orgName: 'All'}];
  taskTypes = [
    'Reminder',
    'Task Reminder',
    'Block Party',
    'Progress Alert',
    'Task Update',
    'Task Creation',
    'Task Assignment',
    'Company creation',
    'Task Notes',
    'Invoice Payment',
    'London bells are ringing',
    'Payme',
    'Notify Mention'
  ];
  reveal: any = {
    externalPost: false,
    mailAttach: false
  };
  toggledEmoji: boolean;
  labelDropdown = false;
  urgentLabelDropdown = false;
  imageLocation = 'https://static.taxplaniq.com/images/';
  togglePostTemplate = false;
  documentsIds: Array<any> = [];
  documentsData: Array<any> = [];
  docData: Array<any> = [];
  

  constructor(
    private dss: DomSanitizer,
    private changeDetectorRef: ChangeDetectorRef,
    private loadingService: LoadingService,
    private toastService: ToastService,
    private taxStrategyServices: ManageTaxStrategiesServices,
    private collaborationService: CollaborationService,
    private switchBoard: SwitchBoard,
    private cacheService: CacheService,
    private titleService: PageTitleService,
    private dateFormater: DateFormater,
  ) {}

  ngOnInit() {
    this.user = Session.getUser();
    this.org = Session.getOrg();
    this.userId = Session.getUser().id;
    this.isCustomer = this.user.isCustomer;
    this.generatedId = this.guid();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  buildItemForm() {
    this.uploader.onBuildItemForm = (fileItem: any, form: any) => {
      const payload: any = {};
      payload.sourceID = this.generatedId;
      payload.sourceType = (this.channelType == 'orgs') ? 'BROADCAST_POST' : 'TODO_POST';
      form.append('payload', JSON.stringify(payload));
    };
    this.uploader.onProgressItem = (fileItem, progress) => {
      if (!(this.changeDetectorRef as ViewRef).destroyed) {
        this.changeDetectorRef.detectChanges();
      }
    };
    this.postUploadResp = [];
    this.uploader.onCompleteItem = (item, response, status, header) => {
      if (status === 200) {
        this.uploadCount++;
        this.postUploadResp.push(JSON.parse(response));
        this.uploader.progress = 100;
        if (this.uploader.queue.length === this.uploadCount) {
          this.toastService.pop(TOAST_TYPE.success, 'Uploaded Successfully');
          this.loadingService.triggerLoadingEvent(false);
          this.uploadCount = 0;
          this.resetUploader();
        } else {
          this.toastService.pop(
            TOAST_TYPE.success,
            this.uploadCount +
            '/' +
            this.uploader.queue.length +
            ' Uploaded Successfully'
          );
          this.loadingService.triggerLoadingEvent(false);
        }
      } else {
        this.toastService.pop(TOAST_TYPE.error, 'Error While Uploading');
        this.uploadCount++;
        if (this.uploader.queue.length === this.uploadCount) {
          this.loadingService.triggerLoadingEvent(false);
          this.uploadCount = 0;
          this.resetUploader();
        }
      }
    };
  }

  uploaderUpdate() {
    const docUrl = this.taxStrategyServices.getVideoDocumentServiceUrl(this.org, Session.getUser().id);
    this.uploader = new FileUploader({
      url: docUrl,
      headers: [
        {
          name: 'Authorization',
          value: 'Bearer ' + Session.getToken()
        }
      ]
    } as FileUploaderOptions);
    this.uploader.onAfterAddingFile = file => {
      file.withCredentials = false;
    };
  }

  setOrgPostType($event) {
    this.orgName = $event.orgId;
  }

  cancelUpload(obj) {
    this.uploader.queue.forEach(function(item) {
      if (item._file.name === obj._file.name) {
        item.remove();
      }
    });
  }

  fileDropOver($event, type, id?: string) {
    const base = this;
    this.attachmentType = type;
    base.uploader.uploadAll();
  }

  s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }

  guid() {
    return (
      this.s4() +
      this.s4() +
      '-' +
      this.s4() +
      '-' +
      this.s4() +
      '-' +
      this.s4() +
      '-' +
      this.s4() +
      this.s4() +
      this.s4()
    );
  }

  editMetaData(value) {
    this.metaDataEdit = value;
    if (!(this.changeDetectorRef as ViewRef).destroyed) {
      this.changeDetectorRef.detectChanges();
    }
  }

  deleteAttachment(attachmentId, obj?) {
    this.postUploadResp = this.postUploadResp.filter((document, tempIndex) => {
      return document.id != attachmentId;
    });
    
   this.taxStrategyServices.removeDocument(this.userId, this.org, attachmentId)
      .subscribe(
        response => {
          if (obj) {
            const index = _.findIndex(obj.documents, {id: attachmentId});
            obj.documents = obj.documents.filter((document, tempIndex) => {
              return index != tempIndex;
            });
          } else {
            if (this.postUploadResp.length === 0) {
              this.resetUploader();
            }
          }
          this.toastService.pop(
            TOAST_TYPE.success,
            'Attachment Deleted Successfully'
          );
        },
        error => {
          const errorObj = JSON.parse(error);
          if (errorObj.message) {
            this.toastService.pop(TOAST_TYPE.error, JSON.parse(error).message);
          } else {
            this.toastService.pop(
              TOAST_TYPE.error,
              'Failed To Delete Attachment'
            );
          }
        }
      );
  }

  resetUploader() {
    /* this.uploader.queue.forEach(function(item) {
     item.remove();
     });*/
    this.uploader.queue = [];
    if (!(this.changeDetectorRef as ViewRef).destroyed) {
      this.changeDetectorRef.detectChanges();
    }
  }

  prependMentions(postObj) {
    const base = this;
    if (this.mentionIds.length > 0) {
      if (this.mentionIds[0].id == 'All') {
        this.mentionIds = [...this.allUsers];
      }
      const mentionString = _.map(this.mentionIds, function(mention) {
        return `@${mention.name}`;
      });
      postObj.mention_message = `${mentionString}:`;
      if (this.pageType == 'teams') {
        postObj.mentionIds = _.map(this.mentionIds, 'userId');
      } else {
        postObj.mentionIds = _.map(this.mentionIds, 'id');
      }
    }
  }

  showMentionWidget() {
    if (this.pageType == 'company' || this.pageType == 'companies') {
      this.allUsers = [...this.users];
      this.mentionUsers = [...this.users];
      this.mentionUsers.unshift({id: 'All', name: 'All'});
    } else if (this.pageType == 'teams') {
      this.mentionUsers = [{
        name: 'Loading...'
      }];
      this.collaborationService.getTeamUsers(this.selectedCompanyId).subscribe(response => {
        this.allUsers = [...response.teamUsers];
        this.mentionUsers = [...response.teamUsers];
        this.mentionUsers.unshift({id: 'All', name: 'All'});
        if (!(this.changeDetectorRef as ViewRef).destroyed) {
          this.changeDetectorRef.detectChanges();
        }
      }, error => {
      });
    }
    setTimeout(() => {
      this.showMentionDropdown = true;
      if (!(this.changeDetectorRef as ViewRef).destroyed) {
        this.changeDetectorRef.detectChanges();
      }
    });
  }

  closeMentionContainer() {
    this.showMentionDropdown = false;
    // this.mentions = _.map(this.mentionIds, 'name');
  }

  mentionSelected($event) {
    if ($event && $event.id == 'All') {
      this.mentionIds = [{id: 'All', name: 'All'}];
      this.mentions = ['All'];
    } else if ($event) {
      const index = _.findIndex(this.mentionIds, {id: $event.id});
      if (index == -1) {
        this.mentionIds = [...this.mentionIds, $event];
        this.mentions = _.map(this.mentionIds, 'name');
      }
    }
    if (!(this.changeDetectorRef as ViewRef).destroyed) {
      this.changeDetectorRef.detectChanges();
    }
  }

  removeMention($event) {
    if ($event && $event.id == 'All') {
      this.mentionIds = [];
      this.mentions = _.map(this.mentionIds, 'name');
    } else if ($event) {
      const index = _.findIndex(this.mentionIds, {id: $event.id});
      if (index !== -1) {
        this.mentionIds = this.mentionIds.filter((entry, idx) => {
          return index != idx;
        });
      }
      this.mentions = _.map(this.mentionIds, 'name');
    }
    if (!(this.changeDetectorRef as ViewRef).destroyed) {
      this.changeDetectorRef.detectChanges();
    }
  }

  startUpload($event, type, id?: string) {
    this.uploader.uploadAll();
  }

  openPostConfirmation() {
    if (
      this.postUploadResp.length > 0 ||
      this.newPost.message !== '' ||
      this.newPost.badges.length > 0
    ) {
      this.reveal = {...this.reveal, externalPost: true};
    }
  }

 createPost() {
    const base = this;
    const isEmpty = this.editor.core.isEmpty();
    // let isEmpty = jQuery(this.newPostEditor.nativeElement).froalaEditor('core.isEmpty');
    if (
      this.postUploadResp.length > 0 || !isEmpty || this.newPost.badges.length > 0 || this.isGify) {
      let obj = {
          firstName: this.user.first_name,
          lastName: this.user.last_name,
          id: Session.getUser().id,
          bot: false,
          badgeName: this.user.first_name.charAt(0) + this.user.last_name.charAt(0),
          thumbnail:  this.user?.thumbnail?.length > 0 ? this.user.thumbnail : '',
        };
      

      this.newPost.user = obj;
      this.newPost.orgId = Session.getOrg();
      this.newPost.internal = this.isCustomer || this.entityType === 'todo' ? false : _.cloneDeep(this.postEntityType);
      this.newPost.postedBy = Session.getUser().id;
      this.newPost.entityID = this.entityId || 'Default';
      this.newPost.entityType = this.entityType || 'Default';
      this.newPost.browserTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      this.newPost.labels = this.selectedLabels;
      this.newPost.urgency_labels = this.selectedUrgentLabels;
      if (this.entityType === 'todo') {
        this.newPost.internal_users = [];
        this.newPost.external_users = [];
      } else if (this.newPost.internal) {
        this.newPost.internal_users = _.map(this.internalMails, 'id');
      } else {
        this.newPost.internal_users = _.map(this.internalMails, 'id');
        this.newPost.external_users = _.map(this.externalMails, 'id');
      }
      if (this.isTeam) {
        this.newPost.internal_users = _.map(this.teamMails, 'userId');
      }
      if (this.postUploadResp.length > 0) {
        this.newPost.documents = [];
        for (const i in this.postUploadResp) {
          const obj: any = {};
          obj.name = this.postUploadResp[i].name;
          obj.id = this.postUploadResp[i].id;
          obj.temporaryURL = this.postUploadResp[i].temporaryURL;
          obj.doc_notes = this.postUploadResp[i].documentNotes
            ? this.postUploadResp[i].documentNotes
            : '';
          this.newPost.documents.push(obj);
        }
        this.newPost.id = this.postUploadResp[0].sourceID;
      } else {
        this.newPost.documents = [];
        this.newPost.id = this.guid();
      }
      if (this.isGify) {
        this.newPost.gifLink = this.gifyUrl;
      }
      if (this.entityId) {
        this.newPost.metaData = this.metaData;
      }
      if (this.documentsIds.length > 0) {
        this.newPost.documents = [...this.newPost.documents, ...this.documentsIds];

      }
      this.newPost.post_handlers = [];
      this.newPost.new = false;
      this.closePostModalDailog();
      this.updateSnapShots(this.newPost);
      this.newPost.displayComments = true;
      this.newPost.html_message = this.newPost.message;
      this.newPost.message = this.newPostEditor.nativeElement.innerText;
      const postObj = _.cloneDeep(this.newPost);
      this.postUploadResp = [];
      if (this.isPostFromMail) {
        this.createPostFromMail(postObj);
      }
      if (this.isOrg) {
        if (Session.getOrg() != 'qount') {
          postObj.entityID = 'qount';
        } else {
          postObj.entityID = this.orgName || '';
        }
        // this.user = Session.getUser();
        postObj.org = {
          id: Session.getOrg(),
          name: this.user.org
        };
        postObj.entityType = 'org';
      }
      if (_.isEmpty(postObj.entityID)) {
        this.closePostModalDailog();
        this.toastService.pop(TOAST_TYPE.warning, 'Please Select Firm To Post');
        return;
      }
      if ((this.cachingPostType === 'all') || (this.cachingPostType === 'internal' && this.newPost.internal) || (this.cachingPostType === 'external' && !this.newPost.internal)) {
        this.posts && this.posts.unshift(_.cloneDeep(this.newPost));
      } else if (!this.cachingPostType) {
        this.posts && this.posts.unshift(_.cloneDeep(this.newPost));
      }

      this.prependMentions(postObj);
      if (!this.newPost.internal) {
        this.showDropdowns = false;
      }
      this.resetPostObj();
      this.loadingService.triggerLoadingEvent(true);
      this.collaborationService
        .createPost(this.org, this.channelType, postObj, this.selectedCompanyId)
        .subscribe(
          response => {
            if (this.integrationPost) {
              this.closeReveal();
              this.cacheService.clearCompanyCache(this.selectedCompanyId);
              this.loadingService.triggerLoadingEvent(false);
              this.toastService.pop(TOAST_TYPE.success, 'Post Created Succesfully');
              return;
            }
            const obj = response;
            if (obj.comments && obj.comments.length > 0) {
              obj.comments[0].children = [];
            } else {
              obj.comments = [];
            }
            if (obj.entityID !== 'Default') {
              obj.metaData = this.metaData;
            }
            this.updateSnapShots(obj);
            obj.displayComments = true;
            if (((this.cachingPostType === 'internal' && this.newPost.internal) || (this.cachingPostType === 'external' && !this.newPost.internal)) && this.posts) {
              this.posts[0] = obj;
            } else if (!this.cachingPostType && this.posts) {
              this.posts[0] = obj;
            }
            this.onPostCreation.next(obj);
            this.postUploadResp = [];
            this.generatedId = this.guid();
            this.attachmentType = '';
            this.orgName = '';
            this.resetUploader();
            this.isCustomer = true;
            setTimeout(() => {
              if (!base.user.isCustomer) {
                base.isCustomer = false;
                base.postEntityType = true;
              }
              if (this.isSecureUploadPost) {
                this.toastService.pop(TOAST_TYPE.success, 'Post created successfully');
                this.switchBoard.onMailPostCreate.next(response);
              }
              if (!(this.changeDetectorRef as ViewRef).destroyed) {
                this.changeDetectorRef.detectChanges();
              }
            });
            this.closeReveal();
          },
          error => {
            this.loadingService.triggerLoadingEvent(false);
            try {

              const message = error.message || 'Failed to Post';
              this.toastService.pop(TOAST_TYPE.error, message);
            } catch (error) {
              const message = `Failed To Post`;
              this.toastService.pop(TOAST_TYPE.error, message);
            }
            if (this.isSecureUploadPost) {
              this.switchBoard.onMailPostCreate.next(error);
            }
            if (this.posts) {
              this.posts.shift();
            }
            this.closePostModalDailog();
            if (!(this.changeDetectorRef as ViewRef).destroyed) {
              this.changeDetectorRef.detectChanges();
            }
          }
        );
    }
  }

  resetPostObj() {
    this.newPost.message = '';
    this.newPost.html_message = '';
    this.newPost.badges = [];
    this.newPost.id = '';
    this.newPost.user = {};
    this.metaData = _.clone(this.metaDataCopy);
    this.metaDataEdit = false;
    this.newPost.documents = [];
    delete this.newPost.mentionIds;
    this.mentionIds = [];
    this.mentions = [];
    this.allUsers = [];
    this.newPost.labelId = '';
    this.selectedUrgentLabelNames = [];
    this.urgencyPostLabels = [];
    this.selectedLabels = [];
    this.selectedLabelNames = [];
    this.postEntityType = true;
    this.isDisplayThanosAlert = false;
    this.gifyUrl = '';
    this.isGify = false;
    this.docData = [];
    this.documentsData = [];
    this.documentsIds = [];
    setTimeout(() => {
      this.showDropdowns = true;
    });
    if (!(this.changeDetectorRef as ViewRef).destroyed) {
      this.changeDetectorRef.detectChanges();
    }
  }

  closePostModalDailog() {
    this.hideReveal('externalPost');
  }

  openLabelsDropdown() {
    setTimeout(() => {
      this.labelDropdown = true;
      if (!(this.changeDetectorRef as ViewRef).destroyed) {
        this.changeDetectorRef.detectChanges();
      }
    });
  }

  closeLabelsDropdown() {
    this.labelDropdown = false;
    if (!(this.changeDetectorRef as ViewRef).destroyed) {
      this.changeDetectorRef.detectChanges();
    }
  }

  labeloptionSelected(label) {
    this.selectedLabels = this.selectedLabels ? this.selectedLabels : [];
    const index = _.findIndex(this.selectedLabels, {labelId: label.labelId});
    if (index == -1) {
      this.selectedLabels = [...this.selectedLabels, label];
      this.selectedLabelNames = _.map(this.selectedLabels, 'labelName');
    }
  }

  labelRemove(label) {
    const index = _.findIndex(this.selectedLabels, {labelId: label.labelId});
    if (index !== -1) {
      this.selectedLabels = _.filter(this.selectedLabels, (label, tempIndex) => {
        return index != tempIndex;
      });
      this.selectedLabelNames = _.map(this.selectedLabels, 'labelName');
    }
  }

  openUrgentLabelsDropdown() {
    setTimeout(() => {
      this.urgentLabelDropdown = true;
      if (!(this.changeDetectorRef as ViewRef).destroyed) {
        this.changeDetectorRef.detectChanges();
      }
    });
  }

  closeUrgentLabelsDropdown() {
    this.urgentLabelDropdown = false;
    if (!(this.changeDetectorRef as ViewRef).destroyed) {
      this.changeDetectorRef.detectChanges();
    }
  }

  urgentLabeloptionSelected(label) {
    this.selectedUrgentLabels = this.selectedUrgentLabels ? this.selectedUrgentLabels : [];
    const index = _.findIndex(this.selectedUrgentLabels, {labelId: label.labelId});
    if (index == -1) {
      this.selectedUrgentLabels = [...this.selectedUrgentLabels, label];
      this.selectedUrgentLabelNames = _.map(this.selectedUrgentLabels, 'labelName');
    }
  }

  urgentLabelRemove(label) {
    const index = _.findIndex(this.selectedUrgentLabels, {labelId: label.labelId});
    if (index !== -1) {
      this.selectedUrgentLabels = _.filter(this.selectedUrgentLabels, (label, tempIndex) => {
        return index != tempIndex;
      });
      this.selectedUrgentLabelNames = _.map(this.selectedUrgentLabels, 'labelName');
    }
  }

  convertMessage(obj) {
    return JSON.parse(obj);
  }

  getRandomSnapShot(type, obj) {
    const base = this;
    const num = Math.floor(Math.random() * obj.length);
    return obj[num];
  }

  getSnapShotColor(type) {
    if (type === 'mountain') {
      return '#16477a';
    } else if (type === 'super_square') {
      return '#33ace0';
    } else {
      return '#14B5F0';
    }
  }

  checkForEntityType(type) {
    if (this.taskTypes.indexOf(type) !== -1) {
      return false;
    } else {
      return true;
    }
  }

  getCurrentCompanyName() {
    if (
      !this.isTeam &&
      !this.isUser
    ) {
      return this.titleService.getPageTitle();
    } else {
      return '';
    }
  }

  updateSnapShots(post) {
    const base = this;
    if (
      post.entityType === 'team summary' ||
      post.entityType === 'Task Summary'
    ) {
      post.message =
        typeof post.message === 'string'
          ? base.convertMessage(post.message)
          : post.message;
      if (post.message.imageType === 'default') {
        post.bottomSnapShot = base.getRandomSnapShot(
          'sub',
          base.defaultSnapShots
        );
      }
    } else if (!base.checkForEntityType(post.entityType)) {
      post.bottomSnapShot1 = base.getRandomSnapShot(
        'sub',
        base.defaultSnapShots
      );
      post.bottomSnapShot2 = base.getRandomSnapShot(
        'sub',
        base.defaultSnapShots
      );
    }
    post.tooltipDate = base.updateDateTimeStamp(post.createdDate);
    post.displayDate = base.updateDateTimeStampForTooltip(post.createdDate);
    post.displayLine = false;
    if (post.entityType === 'org' && post.entityID === '') {
      post.isOrgBroadcast = true;
    }
    post.isBotMessage =
      base.checkForEntityType(post.entityType) &&
      post.entityType !== 'team summary' &&
      post.entityType !== 'Task Summary';
    post.showReminder =
      !base.checkForEntityType(post.entityType) &&
      post.entityType !== 'team summary' &&
      post.entityType !== 'Task Summary';

    /*if (
     post.entityType !== "team summary" ||
     post.entityType !== "Task Summary"
     ) {
     post.snapshotColor = base.getSnapShotColor(post.message.imageType);
     }*/
    post.documents = post.documents ? post.documents : [];

    post.comments = post.comments ? post.comments : [];
    _.each(post.documents, function(attachment) {
      const splitArray = attachment.name.split('.');
      if (
        base.isImage(splitArray[splitArray.length - 1]) &&
        attachment.temporaryURL
      ) {
        attachment.imageType = true;
        attachment.displayImage = true;
      }
    });

    post.comments = post.comments ? post.comments : [];
    _.each(post.comments, function(comment) {
      comment.tooltipDate = base.updateDateTimeStamp(comment.createdDate);
      comment.displayDate = base.updateDateTimeStampForTooltip(
        comment.createdDate
      );
      comment.documents = comment.documents ? comment.documents : [];
      _.each(comment.documents, function(attachment) {
        if (base.isDocView) {
          const splitArray = attachment.name.split('.');
          if (base.isImage(splitArray[splitArray.length - 1])) {
            attachment.imageType = true;
            attachment.displayImage = true;
            attachment.taxCheck = attachment.taxCheck
              ? attachment.taxCheck
              : '#e1e1e1';
          } else if (
            base.docTypeList.indexOf(
              splitArray[splitArray.length - 1].toLowerCase()
            ) != -1
          ) {
            attachment.ispdf = true;
            attachment.displayPdf = true;
            attachment.taxCheck = attachment.taxCheck
              ? attachment.taxCheck
              : '#e1e1e1';
            const link =
              'https://docs.google.com/gview?embedded=true&url=' +
              encodeURIComponent(attachment.temporaryURL);
            setTimeout(function() {
              attachment.pdfLink = base.dss.bypassSecurityTrustResourceUrl(
                link
              );
            }, 0);
          }
        } else {
          const splitArray = attachment.name.split('.');
          if (
            base.isImage(splitArray[splitArray.length - 1]) &&
            attachment.temporaryURL
          ) {
            attachment.imageType = true;
            attachment.displayImage = true;
          }
        }
      });
    });
    return post;
  }

  updateDateTimeStamp(date) {
    const serviceFormat = 'YYYY-MM-DD HH:mm:ss';
    const dateFormat = 'Do MMM, YYYY HH:mm';
    const startTime = moment.utc(date).toDate();
    return this.dateFormater.formatDate(startTime, serviceFormat, dateFormat);
  }

  updateDateTimeStampForTooltip(date) {
    const serviceFormat = 'YYYY-MM-DD HH:mm:ss';
    const dateFormat = 'Do MMM, YYYY HH:mm';
    const startTime = moment.utc(date).toDate();
    return this.dateFormater.formatDate(startTime, serviceFormat, dateFormat);
  }

  createPostFromMail(obj) {
    const base = this;
    const data: any = {};
    data.type = 'post';
    data.messageId = this.mailObj.id;
    data.data = obj;
    data.channel_id = this.selectedCompanyId;
    data.channel_type = this.channelType;
    data.attachments = obj.documents;
    this.collaborationService
      .createEntity(data, this.mailObj)
      .subscribe(
        response => {
          this.toastService.pop(TOAST_TYPE.success, 'Post created successfully');
          this.switchBoard.onMailPostCreate.next(response);
        },
        error => {
        }
      );
  }

  setPostType(type) {
    if (type) {
      this.postEntityType = type === 'internal';
    } else {
      this.postEntityType = false;
    }
    this.showThanosAlert();
  }

  isImage(extension) {
    const imageTypes = ['png', 'jpg', 'jpeg', 'bmp'];
    if (imageTypes.indexOf(extension.toLowerCase()) != -1) {
      return true;
    } else {
      return false;
    }
  }

  showThanosAlert() {
    if (
      !this.postEntityType &&
      !this.isTeam &&
      !this.selectedCompany.bot &&
      !this.isCustomer
    ) {
      this.isDisplayThanosAlert = true;
    } else {
      this.isDisplayThanosAlert = false;
    }
  }

  hideReveal(revealFlag) {
    this.reveal[revealFlag] = false;
  }

  stopPropagation($event) {
    $event && $event.stopImmediatePropagation();
  }

  urltoFile(url, filename, mimeType) {
    return (fetch(url)
        .then(function(res) {
          return res.arrayBuffer();
        })
        .then(function(buf) {
          return new File([buf], filename, {type: mimeType});
        })
    );
  }

  handleEmojiSelection(event) {
    this.newPost.message += '<span title="' + event.label + '"><img class="emoji-button emoji-in-message" src="https://static.taxplaniq.com/images/emojis/' + event.char + '.png"/></span><span> </span>';
  }

  setMailObj() {
    const base = this;
    if (base.mailObj.mailType == 'gmail') {
      base.newPost.message =
        base.mailObj.headers.Subject + ' ' + base.mailObj.decodedData.data;
    } else {
      base.newPost.message =
        base.mailObj.subject + ' ' + base.mailObj.bodyPreview;
    }
    if (
      base.mailObj.attachments &&
      base.mailObj.attachments.length > 0
    ) {
      for (const i in base.mailObj.attachments) {
        let obj = {};
        if (base.mailObj.mailType == 'gmail') {
          obj = {
            name: base.mailObj.attachments[i].filename,
            id: base.mailObj.attachments[i].attachmentId
          };
        } else {
          obj = {
            name: base.mailObj.attachments[i].name,
            id: base.mailObj.attachments[i].id
          };
        }
        base.postUploadResp.push(obj);
      }
    }
    base.attachmentType = 'newPost';
    base.isPostFromMail = true;
  }

  setSecureUploadPost() {
    this.newPost.message = this.mailObj.message;
    this.attachmentType = 'newPost';
    this.postUploadResp = this.mailObj.documents;
  }

  addTags(event, type) {
    if (type == 'teamUsers') {
      this.teamMails.push(event.entry);
      this.teamMails = _.uniqBy(this.teamMails, 'id');
    }
    if (type == 'internals') {
      this.internalMails.push(event.entry);
      this.internalMails = _.uniqBy(this.internalMails, 'id');
    } else {
      this.externalMails.push(event.entry);
      this.externalMails = _.uniqBy(this.externalMails, 'id');
    }
  }

  removeTags(index, type) {
    if (type == 'teamUsers') {
      this.teamMails.splice(index, 1);
    }
    if (type == 'internals') {
      this.internalMails.splice(index, 1);
    } else {
      this.externalMails.splice(index, 1);
    }
  }

  closeReveal() {
    if (this.taskPosts) {
      this.switchBoard.onCreatePost.next('popupPosts');
    } else {
      this.switchBoard.onCreatePost.next({});
    }
    this.loadingService.triggerLoadingEvent(false);
  }

  openGiphy() {
    setTimeout(() => {
      this.toggledGiphy = true;
      this.changeDetectorRef.detectChanges();
    });
  }

  closeHandleContainer(toggleType) {
    if (toggleType === 'giphy') {
      this.toggledGiphy = false;
    } else if (toggleType === 'post-template') {
      this.togglePostTemplate = false;
    }
    this.invokeChangeDetection();
  }

  invokeChangeDetection() {
    if (!(this.changeDetectorRef as ViewRef).destroyed) {
      this.changeDetectorRef.detectChanges();
    }
  }

  handleGiphySelection(event) {
    this.isGify = true;
    this.gifyUrl = event.url;
    this.toggledGiphy = false;
  }

  removeGiphy(gify) {
    gify = '';
    this.gifyUrl = '';
    this.isGify = false;
  }


  openPostTemplatesDropdown() {
    setTimeout(() => {
      this.togglePostTemplate = true;
      this.invokeChangeDetection();
    });
  }

  addTemplateToPost(event) {
    this.newPost.message += ` ${event.content}`;
  }

  openReveal() {
    setTimeout(() => {
      this.reveal = {...this.reveal, mailAttach: true};
      this.changeDetectorRef.detectChanges();
    });
  }

  onCloseReveal(revealFlag) {
    this.reveal[revealFlag] = false;
    if (!(this.changeDetectorRef as ViewRef).destroyed) {
      this.changeDetectorRef.detectChanges();
    }
  }

  removeDocument(doc) {
    const base = this;
    for (let i = 0; i < base.documentsData.length; i++) {
      if (base.documentsData[i].id === doc.id) {
        base.documentsIds.splice(i, 1);
        base.documentsData.splice(i, 1);
      }
    }
  }

  clearAllUsers(type, action) {
    if (type === 'internal') {
      this.internalMails = [];
      if (action === 'clear') {
        this.internalClearAll = false;
      } else if (action === 'add') {
        this.internalClearAll = true;
        this.internalMails = [...this.dupInternalMails];
      }
    } else if (type === 'external') {
      this.externalMails = [];
      if (action === 'clear') {
        this.externalClearAll = false;
      } else if (action === 'add') {
        this.externalClearAll = true;
        this.externalMails = [...this.dupExternalMails];
      }
    } else if (type === 'teams') {
      this.teamMails = [];
      if (action === 'clear') {
        this.teamsClearAll = false;
      } else if (action === 'add') {
        this.teamsClearAll = true;
        this.teamMails = [...this.dupTeamsMails];
      }
    }
  }
}
